import React from 'react';
import { Breadcrumb, useStyles, useTheme } from '@archipro-design/aria';
import * as S from './TopNav.mobile.style';
import type { Crumb } from '@modules/project/util/make-crumbs';
import type { Props as ContactsProps } from '../contacts/Contacts.mobile';

interface TopNavData {
    Breadcrumbs: Crumb[];
}

interface TopNavProps {
    data: TopNavData & ContactsProps['data'];
}

const TopNavMobile = ({ data }: TopNavProps) => {
    const { css } = useStyles();
    const theme = useTheme();

    return (
        <Breadcrumb
            items={data.Breadcrumbs.map((item) => ({
                ...item,
                variables: {
                    breadcrumbItemTextColor:
                        theme.siteVariables.colors.grey['300'],
                },
            }))}
            variables={{
                breadcrumbFontSize: theme.siteVariables.fontSizes.caption04,
            }}
            className={css(S.BreadCrumb)}
        />
    );
};

export default TopNavMobile;
